import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// In-memory cache so we don't ping the same URL twice per session.
const _cache = new Map();

/**
 * Best-effort availability ping. Returns:
 *   { state: "loading" | "unknown" | "likely_full" | "likely_open", reason }
 * Providers heavily obfuscate their HTML — treat "likely_full" as a hint, not truth.
 */
export function useAvailabilityPing({ provider, url, enabled = true } = {}) {
  const [result, setResult] = useState({ state: "unknown", reason: null });

  useEffect(() => {
    if (!enabled || !provider || !url) return;
    const key = `${provider}::${url}`;
    if (_cache.has(key)) {
      setResult(_cache.get(key));
      return;
    }
    let alive = true;
    setResult({ state: "loading", reason: null });
    api.post("/booking/ping", { provider, url })
      .then(r => {
        const d = r.data || {};
        const state = d.likely_no_availability === true ? "likely_full"
                    : d.likely_no_availability === false ? "likely_open"
                    : "unknown";
        const out = { state, reason: d.reason };
        _cache.set(key, out);
        if (alive) setResult(out);
      })
      .catch(() => {
        const out = { state: "unknown", reason: "ping_failed" };
        _cache.set(key, out);
        if (alive) setResult(out);
      });
    return () => { alive = false; };
  }, [provider, url, enabled]);

  return result;
}
